import { Typography, Paper } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { withTranslation, WithTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { login } from '../../../actions/users'
import { bindSubmitActionToPromise } from '../../../utils/forms'
import LoginForm from './LoginForm'

const styles = ({ spacing }: any): any => ({
  container: {
    padding: spacing(),
    marginBottom: '4rem'
  },
  item: {
    margin: spacing(),
    padding: spacing(2),
    textAlign: 'center'
  },
  signup: {
    margin: '15px 0'
  },
  paper: {
    padding: '2rem',
    borderRadius: '10px'
  },
  button: {
    marginTop: '15px',
    color: '#ffffff !important',
    backgroundColor: '#E2EBFD',
    borderColor: '#E2EBFD',
    '&:hover': {
      backgroundColor: '#670033'
    }
  }
})

interface LoginProps extends WithTranslation {
  classes: any
  isAuthenticated: boolean
  loginUser: any
  autoLoggingIn?: boolean
}

const LoginWindow = ({
  classes,
  isAuthenticated,
  loginUser,
  autoLoggingIn,
  t
}: LoginProps) => (
  <div className={classes.container}>
    {isAuthenticated ? (
      <Typography className={classes.signup} variant='body2' gutterBottom>
        {t('login.alreadyLoggedIn')}
      </Typography>
    ) : (
      <Paper elevation={2} className={classes.paper}>
        <Typography variant='h3' style={{ fontSize: '2.5rem' }} gutterBottom>
          {t('login.title')}
        </Typography>
        <LoginForm loginUser={loginUser} classes={classes} autoLoggingIn={autoLoggingIn} />
      </Paper>
    )}
  </div>
)

const mapStateToProps = () => ({
  isAuthenticated: false
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  loginUser: bindSubmitActionToPromise(dispatch, login)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withTranslation()(LoginWindow)))
